// Spanish intro letter for San Juan tour
// This separates the letter text from the component for easier translation

export const sanJuanIntroLetterEs = {
  fromLine: "Del Escritorio de",
  author: "Dr. Arturo Rivera",
  text: `Querido Explorador,

Bienvenido a San Juan, una ciudad de historia, belleza e historias ocultas. Soy un historiador que pasó años buscando el tesoro perdido de Roberto Cofresí, el pirata más legendario de Puerto Rico.

Dicen que su tesoro final fue dejado en algún lugar de estas calles. Lo encontré. Ahora quiero compartir ese viaje contigo. Cada pista te llevará a través del Viejo San Juan, revelando piezas del pasado y poniendo a prueba tu curiosidad.

¡Si resuelves los doce acertijos, puede que incluso te espere un pedazo del tesoro!`,
  beginButton: "Comenzar Aventura →",
  tapToOpen: "Toca para abrir el sobre",
  skipAnimation: "Saltar animación",
  mute: "Silenciar",
  unmute: "Activar sonido",
};
